import { useMemo } from 'react'
import { type IRow, variantActionsProps } from 'shared/ui'
import { type PowerDialer } from 'entities/PowerDialer/model/PowerDialer'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { getPowerDialerActions } from 'widgets/PowerDialer/lib/getPowerDialerActions'
import { useCallPopUpGlobalContext } from 'widgets/CallPopUp/context/callPopUpGlobalContext'
import { usePowerDialerListContext } from 'pages/powerDialer/pages/list/context/powerDialerListContext'

export const usePowerDialerWithActionsRows: () => IRow<PowerDialer>[] = () => {
  const entities = useEntitiesContext()
  const { items, onDelete } = usePowerDialerListContext()
  const callPopUpGlobalStore = useCallPopUpGlobalContext()

  return useMemo(() => {
    return items.map((item) => {
      const row = Object.create(item)
      const actionDisabled = item.status === 'in_progress' && item.isOnlyManualSelection
      const actions = getPowerDialerActions(
        item,
        {
          onSuccessDelete: () => onDelete(item.id),
          fromList: true,
        },
        callPopUpGlobalStore,
        entities
      )

      row.actionsProps = {
        ...variantActionsProps.table,
        actions,
        disabled: actionDisabled,
        moreActionsTooltipProps: {
          ...(actionDisabled && {
            label: 'Power Dialer session in progress',
            maxWidth: '150px',
          }),
        },
      }

      return row
    })
  }, [items])
}
